<div class="container mt-4">

  <!-- Search / Load Society -->
  <div class="card shadow">
    

       <div class="card-header bg-primary text-white">
      <h5 class="mb-0">
        NCD Cooperative Summary
      </h5>
    </div>

    <div class="card-body">

      <div class="row">

        <div class="col-md-4">

          <label class="form-label fw-bold">
            Select Approval Month
          </label>

          <input
            type="month"
            class="form-control"
            [(ngModel)]="selectedMonth"
            (change)="loadApprovedSocieties()"
          />

        </div>

      </div>

    </div>

  </div>


  <!-- ========================= -->
  <!-- APPROVED SOCIETY LIST -->
  <!-- ========================= -->

  <div
    class="card shadow mt-4"
    *ngIf="societies.length > 0"
  >

    <div class="card-header bg-dark text-white">

      <h5 class="mb-0">
        Approved Societies
      </h5>

    </div>


    <div class="card-body">

      <div class=" full-page-table table-responsive ">

      

        <ngx-datatable
    class="ngx-datatable billdata colored-header sm table-striped table-hover"
    [rows]="societies"
    [columns]="columns1"
    [columnMode]="'force'"
    [headerHeight]="50"
    [footerHeight]="50"
    rowHeight="auto"
    [virtualization]="false"
    [scrollbarV]="true"
    [scrollbarH]="true">

    <ngx-datatable-column
        *ngFor="let column1 of columns1; let i = index"
        [name]="column1.name"
        [prop]="column1.prop"
        [width]="column1.width"
        [sortable]="column1.sortable">

        <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex">

            <ng-container [ngSwitch]="column1.prop">


                <!-- ========================= -->
                <!-- SERIAL NUMBER -->
                <!-- ========================= -->

                <ng-container *ngSwitchCase="'id'">

                    {{ rowIndex + 1 }}

                </ng-container>


                <!-- ========================= -->
                <!-- SELECT SOCIETY -->
                <!-- ========================= -->

                <ng-container *ngSwitchCase="'select'">

                    <input
                        type="radio"
                        name="selectedSociety"
                        [value]="row.iSocietyDetailsId"
                        [(ngModel)]="selectedSocietyId"
                        [disabled]="row.ncdUpdated"
                        (change)="selectSociety(row)"
                    />

                </ng-container>


                <!-- ========================= -->
                <!-- SOCIETY NAME -->
                <!-- ========================= -->

                <ng-container *ngSwitchCase="'sSocietyName'">

                    <span
                        class="fw-semibold"
                        [attr.title]="row?.sSocietyName">

                        {{ row?.sSocietyName }}

                    </span>

                </ng-container>


                <!-- ========================= -->
                <!-- REGISTRATION NO -->
                <!-- ========================= -->

                <ng-container *ngSwitchCase="'sSocietyRegistrationNo'">

                    {{ row?.sSocietyRegistrationNo }}

                </ng-container>


                <!-- ========================= -->
                <!-- DISTRICT -->
                <!-- ========================= -->

                <ng-container *ngSwitchCase="'sdistrictname'">

                    {{ row?.sdistrictname }}

                </ng-container>


                <!-- ========================= -->
                <!-- APPROVAL DATE -->
                <!-- ========================= -->

                <ng-container *ngSwitchCase="'dtApprovedate'">

                    {{ row?.dtApprovedate | date:'dd/MM/yyyy' }}

                </ng-container>


                <!-- ========================= -->
                <!-- NCD STATUS -->
                <!-- ========================= -->

                <ng-container *ngSwitchCase="'ncdUpdated'">

                    <span
                        *ngIf="!row?.ncdUpdated"
                        class="badge bg-warning text-dark">

                        Not Updated

                    </span>


                    <span
                        *ngIf="row?.ncdUpdated"
                        class="badge bg-success">

                        Updated

                    </span>

                </ng-container>


                <!-- ========================= -->
                <!-- DEFAULT -->
                <!-- ========================= -->

                <ng-container *ngSwitchDefault>

                    {{ row[column1.prop] }}

                </ng-container>


            </ng-container>

        </ng-template>

    </ngx-datatable-column>

</ngx-datatable>
      </div>

    </div>

  </div>


  <!-- ========================= -->
  <!-- NO DATA -->
  <!-- ========================= -->

  <div
    class="alert alert-info mt-4"
    *ngIf="selectedMonth && !loading && societies.length === 0"
  >

    No approved societies found for the selected month.

  </div>

    <!-- <div class="card-body">

      <form [formGroup]="form">

        <div class="row">
          <div class="col-md-6">

            <label class="form-label fw-bold">
              Society Details ID
            </label>

            <input
              type="number"
              formControlName="societyDetailsId"
              class="form-control"
              placeholder="Enter Society Details ID"
            />

          </div>

          <div class="col-md-6 d-flex align-items-end">

            <button
              type="button"
              class="btn btn-primary"
              (click)="getSocietyDetails()"
              [disabled]="loading"
            >
              <i class="bi bi-search"></i>
              {{ loading ? 'Loading...' : 'Get Society Details' }}
            </button>

          </div>
        </div>

      </form>

    </div>
  </div> -->


  <!-- Society Preview -->
  <div
    class="card shadow mt-4"
    *ngIf="societyDetails"
  >

    <div class="card-header bg-warning">
      <h5 class="mb-0">
        Society Details Preview
      </h5>
    </div>

    <div class="card-body">

      <div class="row">

        <div class="col-md-4 mb-3">
          <strong>Society Details ID</strong>
          <div>{{ societyDetails.iSocietyDetailsId }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Society Name</strong>
          <div>{{ societyDetails.sSocietyName }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Registration No</strong>
          <div>{{ societyDetails.sSocietyRegistrationNo }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Society Type</strong>
          <div>{{ societyDetails.ssocietytypename }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Category</strong>
          <div>{{ societyDetails.scategoryname }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Kind</strong>
          <div>{{ societyDetails.ssocietykindname }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Division</strong>
          <div>{{ societyDetails.sdivisionname }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>District</strong>
          <div>{{ societyDetails.sdistrictname }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Block</strong>
          <div>{{ societyDetails.sblockname }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Panchayat</strong>
          <div>{{ societyDetails.spanchayatname }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Village</strong>
          <div>{{ societyDetails.svillagename }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Pincode</strong>
          <div>{{ societyDetails.sPincode }}</div>
        </div>

        <div class="col-md-6 mb-3">
          <strong>Address</strong>
          <div>{{ societyDetails.Address || societyDetails.sAddress1 }}</div>
        </div>

        <div class="col-md-3 mb-3">
          <strong>Mobile</strong>
          <div>{{ societyDetails.Mobile }}</div>
        </div>

        <div class="col-md-3 mb-3">
          <strong>Email</strong>
          <div>{{ societyDetails.Email }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Share Value</strong>
          <div>{{ societyDetails.shareValue }}</div>
        </div>

        <div class="col-md-4 mb-3">
          <strong>Total Amount</strong>
          <div>{{ societyDetails.totalAmount }}</div>
        </div>

      </div>

      <hr>

      <div class="alert alert-info mb-3">
        <strong>Confirmation:</strong>
        Please review the above society details before sending them to NCD.
      </div>

      <button
        type="button"
        class="btn btn-success me-2"
        (click)="confirmSendSummary()"
      >
        <i class="bi bi-send"></i>
        Send/Update Cooperative Summary NCD Data
      </button>

      <button
        type="button"
        class="btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#deleteConfirmModal"
      >
        <i class="bi bi-trash"></i>
        Delete From NCD Data
      </button>

    </div>
  </div>


  <!-- JSON Payload + API Response -->
  <div
    class="row"
    *ngIf="jsonPayload || apiResponse"
  >

    <!-- JSON Payload -->
    <div
      class="col-md-6"
      *ngIf="jsonPayload"
    >

      <div class="card shadow mt-4">

        <div class="card-header bg-dark text-white">
          JSON Payload
        </div>

        <div class="card-body">

          <pre class="json-box">{{ jsonPayload | json }}</pre>

        </div>

      </div>

    </div>


    <!-- API Response -->
    <div
      class="col-md-6"
      *ngIf="apiResponse"
    >

      <div class="card shadow mt-4">

        <div class="card-header bg-info text-white">
          API Response
        </div>

        <div class="card-body">

          <pre class="json-box">{{ apiResponse | json }}</pre>

        </div>

      </div>

    </div>

  </div>


</div>


<!-- ========================= -->
<!-- NCD UPDATE CONFIRM MODAL -->
<!-- ========================= -->

<div
  class="modal fade"
  id="ncdUpdateConfirmModal"
  tabindex="-1"
>

  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">

      <div class="modal-header bg-success text-white">

        <h5 class="modal-title">
          Confirm NCD Update
        </h5>

        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
        ></button>

      </div>

      <div class="modal-body">

        <p>
          Are you sure you want to update the following cooperative
          summary to NCD?
        </p>

        <div class="alert alert-warning">

          <strong>
            {{ societyDetails?.sSocietyName }}
          </strong>

          <br>

          Registration No:
          {{ societyDetails?.sSocietyRegistrationNo }}

        </div>

        <p class="mb-0">
          Please confirm that the above information is correct.
        </p>

      </div>

      <div class="modal-footer">

        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn btn-success"
          (click)="sendSummary()"
          data-bs-dismiss="modal"
        >
          <i class="bi bi-check-circle"></i>
          Yes, Update NCD
        </button>

      </div>

    </div>

  </div>

</div>


<!-- ========================= -->
<!-- DELETE CONFIRM MODAL -->
<!-- ========================= -->

<div
  class="modal fade"
  id="deleteConfirmModal"
  tabindex="-1"
>

  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">

      <div class="modal-header bg-danger text-white">

        <h5 class="modal-title">
          Confirm Delete
        </h5>

        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
        ></button>

      </div>

      <div class="modal-body">

        <p class="mb-0">
          Are you sure you want to
          <strong>soft delete</strong>
          this cooperative summary?
        </p>

      </div>

      <div class="modal-footer">

        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn btn-danger"
          (click)="softDelete()"
          data-bs-dismiss="modal"
        >
          Yes Delete
        </button>

      </div>

    </div>

  </div>

</div>